import React from 'react';
import { StandardListLayout } from '@/shared/layout/StandardListLayout';
import { AgroRatesKpi } from './components/AgroRatesKpi';
import { AgroRatesFilter } from './components/AgroRatesFilter';
import { AgroRatesTable } from './components/AgroRatesTable';

export default function AgroRatesListPage() {
  return (
    <StandardListLayout
      title="Đơn giá & Dự toán Vật tư"
      description="Quản lý đơn giá dự toán, theo dõi và đối chiếu biến động với giá nhập thực tế."
      kpiSection={<AgroRatesKpi />}
      toolbarSection={<AgroRatesFilter />}
      contentSection={<AgroRatesTable />}
    />
  );
}
